// getInsurancePlanNameAbbreviation renders MCO plans as "Margin Cov Opt-RP" — too long for
// a chip. Render MCO as "MCO / 95 %" and delegate everything else to the toolkit as-is.

import { getComboTitle } from "@datanac/datanac-api-toolkit/dist/insurance/optimizer/optimizer";

import { isMcoPlan } from "./isMcoPlan.js";

function mcoTitle(plan) {
  const coverage = plan?.coverage_level_percent ?? plan?.insurancePlanParameters?.coverage_level_percent;
  return `MCO / ${Math.round(Number(coverage) * 100)} %`;
}

/** Drop-in replacement for the toolkit's getComboTitle — same signature, MCO-aware. */
export function comboTitle(plans) {
  return (plans || []).map((p) => (isMcoPlan(p) ? mcoTitle(p) : getComboTitle([p]))).join(", ");
}
